import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ExpiringContractsServiceData, InmediateExpiringContractsService } from "../../services/contractsKpi/expiringContracts.service";
import { ExpiringContractsDetailServiceData, InmediateExpiringContractsDetailService, ContractDetail } from "../../services/contractsKpi/expiringContractsDetail.service";
import { EmailColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition, DateColumnDefinition, NumberColumnDefinition, LinkColumnDefinition, LinkColumnData } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ContractsDetailData } from "./contractsDetailData";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { ContractsKpiCfg, ContractsKpiCfgService } from "../../services/contractsKpi/contractsKpiCfg.service";

@Component({
    selector: 'inmediate-expiring-contracts-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class InmediateExpiringContractsKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<InmediateExpiringContractsService, ExpiringContractsServiceData, ExpiringContractsServiceData, InmediateExpiringContractsDetailService, ExpiringContractsDetailServiceData, ContractsDetailData>
    implements OnDestroy {
    public getClassName() { return "InmediateExpiringContractsKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: InmediateExpiringContractsService, detailService: InmediateExpiringContractsDetailService, private serviceCfg: ContractsKpiCfgService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });

    }

    protected processSummaryData(data: ExpiringContractsServiceData): ExpiringContractsServiceData {
        return data;
    }

    protected getDefaultSummaryData(): ExpiringContractsServiceData {
        let data = new ExpiringContractsServiceData();
        data.consultant = 0;
        data.office = 0;
        data.updateTimestamp = new Date();
        return data;
    }

    protected extractUpdateTime(data: ExpiringContractsServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ExpiringContractsDetailServiceData, args: any): ContractsDetailData {
        if (data.contracts) {
            let cfg: ContractsKpiCfg = this.serviceCfg.getCfg();

            data.contracts.sort((a, b) => moment(a.endDate).diff(moment(b.endDate)));

            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = [
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new LinkColumnDefinition("Trabajador", null, true),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                    new TextColumnDefinition("Perfil solicitado", null, true),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[7].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[0].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata = [];
                let tabledata2 = [];
                for (let contract of data.contracts) {
                    if (contract.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            new LinkColumnData(contract.workername, cfg.urlTalent + 'candidates/' + contract.workerId),
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.name,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                            contract.nameLastJob
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            new LinkColumnData(contract.workername, cfg.urlTalent + 'candidates/' + contract.workerId),
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.name,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                            contract.nameLastJob
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = [
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Perfil solicitado", null, true),
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new LinkColumnDefinition("Trabajador", null, true),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[2].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata = [];
                let tabledata2 = [];
                for (let contract of data.contracts) {
                    if (contract.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.name,
                            contract.nameLastJob,
                            contract.endDate,
                            contract.clientFiscalName,
                            new LinkColumnData(contract.workername, cfg.urlTalent + 'candidates/' + contract.workerId),
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.name,
                            contract.nameLastJob,
                            contract.endDate,
                            contract.clientFiscalName,
                            new LinkColumnData(contract.workername, cfg.urlTalent + 'candidates/' + contract.workerId),
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: ContractDetail[]): { nif: string, name: string }[] {
        let nifs: { nif: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!nifs.find(y => x.nif.toUpperCase() == y.nif)) nifs.push({ nif: x.nif.toUpperCase(), name: x.name });
            })
        }

        return nifs;
    }

    protected getDefaultDetailData(): ContractsDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Perfil solicitado", null, true),
            new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
            new TextColumnDefinition("Cliente", null, true),
            new LinkColumnDefinition("Trabajador", null, true),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
            new NumberColumnDefinition("Tp. Contrato"),
            new TextColumnDefinition("Nombre interlocutor", null, true),
            new PhoneNumberColumnDefinition("Teléfono interlocutor"),
        ];

        return new ContractsDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
